const landing = {
    hero: {
        title: 'Book unique experiences in Abruzzo',
        subtitle: 'Discover the beauty of Italy\'s hidden gem',
        cta: 'GET STARTED'
    },
    trips: {
        title: 'Our Trips',
        subtitle: 'Explore our curated experiences',
        summerTrip: {
            title: 'Summer Adventure',
            description: 'Experience the best of Abruzzo in summer',
            price: 'From €299'
        },
        winterTrip: {
            title: 'Winter Landscape',
            description: 'Discover the winter magic of Abruzzo',
            price: 'From €399'
        }
    },

    tripStatus: {
        comingSoon: 'The trip will be available soon, stay tuned ❤️'
    },
    destinations: {
        title: 'Popular Destinations',
        subtitle: 'Must-see places in Abruzzo',
        roccaCalascio: {
            title: 'Rocca Calascio',
            description: 'The village in the clouds'
        },
        collaltoSabino: {
            title: 'Collalto Sabino',
            description: 'The medieval village of Sabina'
        },
        santoStefanoDiSessanio: {
            title: 'Santo Stefano di Sessanio',
            description: 'The medieval gem of Gran Sasso'
        },
        trabocchiCoast: {
            title: 'Trabocchi Coast',
            description: 'The enchanted coast of the trabocchi'
        },
        campoImperatore: {
            title: 'Campo Imperatore',
            description: 'The Little Tibet of Abruzzo'
        },
        scanno: {
            title: 'Scanno',
            description: 'The Village of Jewelry and the Lake'
        }
    },
    activities: {
        title: 'Browse Activities',
        subtitle: 'Adventure awaits you in Abruzzo', deerWatching: {
            title: 'Wild Life Spotting',
            description: 'Discover wildlife in the national park'
        },
        wineTasting: {
            title: 'Wine Tasting',
            description: 'Taste local wines and typical products'
        },
        arrosticiniMucciante: {
            title: 'Arrosticini Mucciante',
            description: 'The Abruzzo culinary tradition'
        },
        sextantio: {
            title: 'Sextantio',
            description: 'The scattered hotel of the village'
        }
    },
    curiosities: {
        title: 'Curiosities',
        subtitle: 'Discover the secrets of Abruzzo',
        wildlife: {
            title: 'Wildlife',
            description: 'The wildlife of Abruzzo'
        },
        gastronomy: {
            title: 'Gastronomy',
            description: 'The authentic flavors of Abruzzo'
        },
        history: {
            title: 'History'
        }
    },
    products: {
        title: 'Our Products',
        subtitle: 'Discover the authentic flavors of Abruzzo with our selection of typical products',
        viewAll: 'View All Products',
        moreComingSoon: 'More products coming soon'
    },
    footer: {
        about: 'About Us',
        contact: 'Contact',
        privacy: 'Privacy',
        terms: 'Terms and Conditions',
        companyDescription: 'Unique experiences in Abruzzo. Discover the beauty of nature, villages, and Italian culture.',
        quickLinks: 'Quick Links',
        followUs: 'Follow Us',
        followUsDescription: 'Stay updated on our latest experiences and special offers.',
        copyright: '© 2025 La Dolce Vita Reis. All rights reserved.',
        cookiePolicy: 'Cookie Policy',
        manageCookies: 'Manage Cookies',
        creativeCommons: 'Images licensed under Creative Commons — ',
        fullCredits: 'full credits here.'
    },
    cookieBanner: {
        title: '🍪 We use cookies',
        description: 'We use cookies mainly for analytics and to improve your experience. System cookies are automatically accepted. By accepting, you consent to the use of these cookies. You can manage your preferences or learn more about our cookie policy.',
        privacyPolicy: 'Privacy Policy',
        termsAndConditions: 'Terms and Conditions',
        acceptAll: 'Accept All',
        rejectAll: 'Reject All',
        managePreferences: 'Manage Preferences'
    },
    cookieModal: {
        title: '🍪 Manage Cookie Preferences',
        necessaryCookies: 'Necessary Cookies',
        alwaysActive: 'Always Active',
        necessaryDescription: 'These cookies are essential for the website to function and cannot be disabled.',
        analyticsCookies: 'Analytics Cookies',
        analyticsDescription: 'These cookies help us improve the site by analyzing how it is used.',
        moreInfo: 'You can change your preferences at any time. For more information, see our',
        cookiePolicy: 'Cookie Policy',
        savePreferences: 'Save Preferences',
        acceptAll: 'Accept All',
        rejectAll: 'Reject All',
        cancel: 'Cancel'
    }
};

export default landing;
